import React from 'react';
import PropTypes from 'prop-types';

import { useClassName } from 'common/hooks';
import { SVGIcon } from 'common/components';

import './profile-picture.less';

export const ProfilePicture = ({ picture, name = '', squared }) => {
  const className = useClassName('ProfilePicture');
  const shape = squared ? 'picture--squared' : 'picture--round';

  if (!picture)
    return (
      <div className={className(['picture', 'picture--placeholder', shape])}>
        {name ? name.charAt(0).toUpperCase() : <SVGIcon name="icon-user" />}
      </div>
    );

  return (
    <img className={className(['picture', shape])} src={picture} alt={name} />
  );
};

ProfilePicture.propTypes = {
  picture: PropTypes.string,
  name: PropTypes.string,
  squared: PropTypes.bool,
};
